var render, staticRenderFns
import script from "./ReaderNavigationMixin.vue?vue&type=script&lang=js&"
export * from "./ReaderNavigationMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReaderNavigationMixin.vue"
export default component.exports